<!--
The "options" property expects an array of objects that contain the following fields:

value    - value of an element, used as key for the list (must be unique)
name     - label displayed next to the radio button
-->

<template>
  <div class="radiolist">
    <div v-for="(option, index) in options" :key="option.value" class="radiolist-item">
      <input type="radio"
        :class="{
          'radiolist-item__radiobutton': true,
          'radiolist-item__radiobutton--selected': option.value === value,
          'radiolist-item__radiobutton--disabled': !option.enabled,
        }"
        :id="`${id}-${index}`"
        :disabled="!option.enabled"
        :value="option.value" v-model="selected">
      <label :for="`${id}-${index}`" v-html="option.name" :class="{
        'radiolist-item__label': true,
        'radiolist-item__label--selected': option.value === value,
        'radiolist-item__label--disabled': !option.enabled,
      }" @click="$emit('input', option.value)" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import RandomIdGenerator from '@/utils/RandomIdGenerator'

@Component({
  components: {
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  watch: {
    value (newValue) {
      this.selected = newValue
    },
  },
})
export default class RadioList extends Vue {
  selected = String(this.value)
  id = RandomIdGenerator.newId()
}
</script>

<style lang="scss">
.radiolist-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 23px;
  padding: 7px 7px 0 7px;
  position: relative;

  @include media(tablet) {
    margin: 0 0 10px;
    padding: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__label {
    font-family: 'Gotham Book';
    font-weight: 300;
    font-size: 14px;
    position: relative;
    padding: 0 0 0 1.5em;
    vertical-align: middle;
    user-select: none;
    cursor: default;

    @include media(tablet) {
      font-size: 12px;
    }

    &--selected {
      color: #005ca9;
    }

    &--disabled {
      color: #ADADAD;
    }

    &:hover:not(&--disabled) {
      color: #009FEA;
      cursor: pointer;
    }

    &::before,
    &::after {
      border-radius: 50%;
    }
    &::before {
      content: '';
      box-sizing: content-box;
      background-color: #eeeeee;
      position: absolute;
      top: 2px;
      left: 0;
      width: 5px;
      height: 5px;
      margin-top: 0;
      border: 4px solid #eeeeee;
      text-align: center;
    }
    &::after {
      content: '';
      box-sizing: content-box;
      background-color: #005ca9;
      position: absolute;
      top: 6px;
      left: 4px;
      width: 5px;
      height: 5px;
      margin-top: 0;
      transform: scale(0);
      transform-origin: 50%;
      transition: transform 200ms ease-out;
    }
  }

  &__radiobutton {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    box-sizing: border-box;

    &:checked + .radiolist-item__label::after {
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RadioList.vue